function c(r, t) {
  var e = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (e) return (e = e.call(r)).next.bind(e);
  if (Array.isArray(r) || (e = v(r)) || t) {
    e && (r = e);
    var a = 0;
    return function() {
      return a >= r.length ? { done: !0 } : { done: !1, value: r[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function v(r, t) {
  if (r) {
    if (typeof r == "string") return l(r, t);
    var e = Object.prototype.toString.call(r).slice(8, -1);
    if (e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set") return Array.from(r);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return l(r, t);
  }
}
function l(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var e = 0, a = new Array(t); e < t; e++)
    a[e] = r[e];
  return a;
}
var p = "x", i = new RegExp(p);
function y(r, t) {
  if (t < 1)
    return "";
  for (var e = ""; t > 1; )
    t & 1 && (e += r), t >>= 1, r += r;
  return e + r;
}
function s(r, t) {
  return r[t] === ")" && t++, h(r.slice(0, t));
}
function h(r) {
  for (var t = [], e = 0; e < r.length; )
    r[e] === "(" ? t.push(e) : r[e] === ")" && t.pop(), e++;
  var a = 0, n = "";
  t.push(r.length);
  for (var u = 0, f = t; u < f.length; u++) {
    var o = f[u];
    n += r.slice(a, o), a = o + 1;
  }
  return n;
}
function d(r, t, e) {
  for (var a = c(e.split("")), n; !(n = a()).done; ) {
    var u = n.value;
    if (r.slice(t + 1).search(i) < 0)
      return;
    t = r.search(i), r = r.replace(i, u);
  }
  return [r, t];
}
export {
  p as DIGIT_PLACEHOLDER,
  s as cutAndStripNonPairedParens,
  d as populateTemplateWithDigits,
  y as repeat,
  h as stripNonPairedParens
};
//# sourceMappingURL=design-system.es876.js.map
